/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-curly-newline */
// #useAuthUpdated
/* eslint-disable no-unreachable */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Select from "react-select";
import DateFnsUtils from "@date-io/date-fns";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Alert from "@material-ui/lab/Alert";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useHistory } from "react-router-dom";
import {
  provinces,
  countryCodes,
  banks,
  tShirtSizes,
  bankAccountTypes,
} from "../shared/constants";
import snakeToCamel from "../shared/functions/snakeToCamel";
import { useUser } from "../../features/users/hooks/useUser";
import ChangePhoneNumber from "./ChangePhone";
import ChangeEmail from "./ChangeEmail";
import * as API from "../../api";

/**
 * Handles all the logic for editing a dealer's profile.
 * @param {object} props Component props.
 * @param {boolean} props.dialogIsOpen Whether the dialog is open or not.
 * @param {Function} props.closeDialog Function to close the dialog.
 * @param {boolean} props.editing Whether the user is editing their own profile or not.
 * @param {Function} props.openSnackbar Function to open a snackbar.
 * @param {object} props.dealerProp The dealer object to edit.
 * @param {object} props.bankingDetails The banking details object.
 * @returns {React.ReactElement} The JSX element to render.
 */
export default function EditProfile(props) {
  const {
    dialogIsOpen,
    closeDialog,
    editing,
    openSnackbar,
    dealerProp,
    bankingDetails,
  } = props;

  const { updateUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [bankAccountNumberHelperText, setBankAccountNumberHelperText] =
    useState("");
  const [bankAccountNumberIsInvalid, setBankAccountNumberIsInvalid] =
    useState(false);
  const [dealerState, setDealerState] = useState([]);
  const [phoneChanged, setPhoneChanged] = useState(false);
  const [emailChanged, setEmailChanged] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const transformedDealerProp = snakeToCamel(dealerProp);
    setDealerState({
      ...transformedDealerProp,
      bank: bankingDetails?.bank || "",
      branchCode: bankingDetails?.branch_code || "",
      accountNumber: bankingDetails?.account_number || "",
      refsBankAccountType: bankingDetails?.account_type || null,
    });
  }, [dealerProp, bankingDetails]);

  /**
   * Handles the submission process for updating a dealer's profile.
   * Uses the updateUser context method to update dealer information.
   */
  const handleSubmit = async () => {
    setError("");
    setLoading(true);

    if (bankAccountNumberIsInvalid) {
      setError(bankAccountNumberHelperText);
      setLoading(false);
      return;
    }

    // Validation
    if (!dealerState.street?.length) {
      setError("Please add a Street Address");
      setLoading(false);
      return;
    }
    if (!dealerState.suburb?.length) {
      setError("Please add a Suburb");
      setLoading(false);
      return;
    }
    if (!dealerState.postalCode?.length) {
      setError("Please add a Postal Code");
      setLoading(false);
      return;
    }
    if (!dealerState.city?.length) {
      setError("Please add a City");
      setLoading(false);
      return;
    }

    if (dealerState.refsPaymentType === "bank") {
      if (!dealerState.bank?.length) {
        setError("Please select a bank");
        setLoading(false);
        return;
      }
      if (!dealerState.accountNumber?.length) {
        setError("Please add a bank account number");
        setLoading(false);
        return;
      }
      if (!dealerState.refsBankAccountType) {
        setError("Please select an account type");
        setLoading(false);
        return;
      }
    }

    if (!dealerState.agreedToRicaTerms) {
      setError("Please check RICA And POPIA Training");
      setLoading(false);
      return;
    }

    try {
      // Prepare update data using the same structure as UserDetail
      const updateData = {
        // Address information
        province: dealerState.province,
        street: dealerState.street,
        suburb: dealerState.suburb,
        city: dealerState.city,
        postalCode: dealerState.postalCode,
        country: dealerState.country,

        // Payment information
        refsPaymentType: dealerState.refsPaymentType,
        refsBankAccountType: dealerState.refsBankAccountType,

        // Personal information
        refsShirtSize: dealerState.refsShirtSize,

        // Banking details
        bank: dealerState.bank,
        bankAccountNumber: dealerState.accountNumber,
        branchCode: dealerState.branchCode,
      };

      // Handle phone and email changes
      if (phoneChanged) {
        updateData.phone = dealerState.phone;
      }

      if (emailChanged) {
        updateData.email = dealerState.email;
      }

      // Use the updateUser context method
      const success = await updateUser(dealerState.id, updateData);

      if (success) {
        // Handle phone/email verification if changed
        if (phoneChanged || emailChanged) {
          try {
            const updateAndSendVerification = await API.updateEmailAndPhone({
              authId: dealerState.authId,
              email: dealerState.email,
              phone: dealerState.phone,
              emailChanged,
              phoneChanged,
            });

            if (updateAndSendVerification.data.code === 200) {
              setLoading(false);
              setDealerState([]);
              closeDialog();
              if (phoneChanged) {
                history.push("/verify-phone");
              }
            } else {
              setError(updateAndSendVerification.data.message);
              setLoading(false);
            }
          } catch (verificationError) {
            console.warn("Verification update failed:", verificationError);
            // Still close dialog as main update succeeded
            setLoading(false);
            setDealerState([]);
            closeDialog();
          }
        } else {
          setLoading(false);
          setDealerState([]);
          closeDialog();
        }

        if (!editing) {
          openSnackbar();
        }
      } else {
        setError("Failed to update profile. Please try again.");
        setLoading(false);
      }
    } catch (error2) {
      setError(
        error2.message || "An error occurred while updating your profile"
      );
      setLoading(false);
    }
  };

  // Handles bank account numbers
  const handleSetBankAccountNumber = async numberLocal => {
    setDealerState({ ...dealerState, accountNumber: numberLocal });

    const numberLocalString = numberLocal.toString();
    if (numberLocalString.length < 6) {
      setBankAccountNumberHelperText("Account number is incomplete");
      setBankAccountNumberIsInvalid(true);
    } else {
      setBankAccountNumberHelperText("");
      setBankAccountNumberIsInvalid(false);
    }
  };

  const handleTrained = () => {
    setDealerState({
      ...dealerState,
      agreedToRicaTerms: !dealerState.agreedToRicaTerms,
    });
  };

  return (
    <div>
      <Dialog
        open={dialogIsOpen}
        onClose={() => {
          setDealerState([]);
          closeDialog();
        }}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "16px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DialogTitle
          style={{
            flex: 1,
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
          }}
        >
          Edit Profile
        </DialogTitle>
        <DialogContent style={{ margin: "15px" }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <form onSubmit={handleSubmit}>
              <Typography
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "black",
                  marginBottom: "-10px",
                }}
              >
                Address
              </Typography>
              <div style={styles.inputContainer}>
                <FormLabel
                  component="legend"
                  style={{ fontSize: ".85rem", marginBottom: 16 }}
                >
                  Country of Residence
                </FormLabel>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  options={countryCodes}
                  defaultValue={countryCodes.find(
                    item => item.value === dealerState.country
                  )}
                  onChange={e => {
                    setDealerState({
                      ...dealerState,
                      country: e.value,
                    });
                  }}
                  placeholder="Country of Residence"
                />
              </div>
              <div style={styles.inputContainer}>
                <FormLabel
                  component="legend"
                  style={{ fontSize: ".85rem", marginBottom: 16 }}
                >
                  Province of Residence
                </FormLabel>
                <Select
                  xs={12}
                  required
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  options={provinces}
                  defaultValue={provinces.find(
                    item => item.value === dealerState.province
                  )}
                  onChange={e => {
                    setDealerState({
                      ...dealerState,
                      province: e.value,
                    });
                  }}
                  placeholder="Select Province"
                />
              </div>
              <div style={styles.inputContainer}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Street address"
                  variant="outlined"
                  fullWidth
                  value={dealerState.street}
                  onChange={e => {
                    setDealerState({
                      ...dealerState,
                      street: e.target.value,
                    });
                  }}
                  required
                />
              </div>
              <div style={styles.inputContainer}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Suburb"
                  variant="outlined"
                  fullWidth
                  value={dealerState.suburb}
                  onChange={e => {
                    setDealerState({
                      ...dealerState,
                      suburb: e.target.value,
                    });
                  }}
                  required
                />
              </div>
              <div style={styles.inputContainer}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Postal Code"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={dealerState.postalCode}
                  onChange={e => {
                    if (e.target.value.length < 5) {
                      setDealerState({
                        ...dealerState,
                        postalCode: e.target.value,
                      });
                    }
                  }}
                />
              </div>
              <div style={styles.inputContainer}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="City"
                  variant="outlined"
                  fullWidth
                  value={dealerState.city}
                  onChange={e => {
                    setDealerState({
                      ...dealerState,
                      city: e.target.value,
                    });
                  }}
                  required
                />
              </div>
              <div style={styles.inputContainer}>
                <FormLabel
                  component="legend"
                  style={{ fontSize: ".85rem", marginBottom: 16 }}
                >
                  T-Shirt Size
                </FormLabel>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  options={tShirtSizes}
                  value={tShirtSizes.find(
                    item => item.value === dealerState.refsShirtSize
                  )}
                  onChange={e => {
                    setDealerState({
                      ...dealerState,
                      refsShirtSize: e.value,
                    });
                  }}
                />
              </div>
              <Divider style={{ margin: 20 }} />
              <div style={styles.inputContainer}>
                <FormControl component="fieldset" required>
                  <FormLabel component="legend" style={{ fontSize: ".85rem" }}>
                    Payment Type
                  </FormLabel>
                  <RadioGroup
                    row
                    required
                    aria-label="payment-type"
                    name="payment-type"
                    value={dealerState.refsPaymentType}
                    onChange={e => {
                      setDealerState({
                        ...dealerState,
                        refsPaymentType: e.target.value,
                      });
                    }}
                  >
                    <FormControlLabel
                      value="bank"
                      control={<Radio />}
                      label="Bank"
                    />
                    <FormControlLabel
                      value="eWallet"
                      control={<Radio />}
                      label="eWallet"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {dealerState.refsPaymentType === "bank" && (
                <>
                  <div style={styles.inputContainer}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={banks}
                      onChange={e => {
                        setDealerState({
                          ...dealerState,
                          bank: e.value,
                          branchCode: banks.filter(
                            item => item.value === e.value
                          )[0].branchCode,
                        });
                      }}
                      defaultValue={
                        dealerState.bank
                          ? {
                              label: dealerState.bank,
                              value: dealerState.bank,
                            }
                          : null
                      }
                      placeholder="Bank"
                    />
                  </div>
                  <div style={styles.inputContainer}>
                    <FormLabel
                      component="legend"
                      style={{ fontSize: ".85rem", marginBottom: 16 }}
                    >
                      Account Type
                    </FormLabel>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={bankAccountTypes}
                      value={bankAccountTypes.find(
                        item => item.value === dealerState.refsBankAccountType
                      )}
                      onChange={e => {
                        setDealerState({
                          ...dealerState,
                          refsBankAccountType: e.value,
                        });
                      }}
                      placeholder="Select Account Type"
                    />
                  </div>
                  <div style={styles.inputContainer}>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      type="number"
                      variant="outlined"
                      label="Account Number"
                      placeholder="Account Number"
                      helperText={bankAccountNumberHelperText}
                      error={bankAccountNumberIsInvalid}
                      value={dealerState.accountNumber}
                      onChange={e => handleSetBankAccountNumber(e.target.value)}
                      fullWidth
                      required
                      inputProps={{
                        minLength: 6,
                        maxLength: 20,
                      }}
                    />
                  </div>
                </>
              )}
              {dealerState.refsPaymentType === "eWallet" && (
                <div style={styles.inputContainer}>
                  <Typography>
                    We will use <b>{dealerState.phone}</b> for eWallet payments.
                  </Typography>
                </div>
              )}
              <Divider style={{ margin: 20 }} />
              <Typography
                style={{ marginBottom: 10, marginTop: 20, fontWeight: "bold" }}
              >
                Change Contact Details
              </Typography>
              <ChangePhoneNumber
                currentPhone={dealerState.phone}
                setNewPhone={newPhone => {
                  setDealerState(prev => ({ ...prev, phone: newPhone }));
                  setPhoneChanged(true);
                }}
              />
              <ChangeEmail
                currentEmail={dealerState.email}
                setNewEmail={newEmail => {
                  setDealerState(prev => ({ ...prev, email: newEmail }));
                  setEmailChanged(true);
                }}
              />
              <Divider style={{ margin: 20 }} />
              <Grid item style={{ paddingTop: 30 }}>
                <Typography
                  style={{
                    fontSize: "1rem",
                    fontWeight: "bold",
                    color: "black",
                    marginBottom: "10px",
                  }}
                >
                  T&Cs
                </Typography>
                <FormControl
                  component="fieldset"
                  required
                  disabled={editing && dealerState.agreedToRicaTerms}
                  style={{ marginLeft: "10px" }}
                >
                  {" "}
                  <FormLabel
                    component="legend"
                    style={{
                      fontSize: "0.85rem",
                      textOverflow: "ellipsis",
                      width: fullScreen ? "100%" : "65%",
                      paddingBottom: "10px",
                    }}
                  >
                    Please note that Zawadi does not take any responsibility for
                    incorrect bank details or cellphone numbers submitted. We
                    will not be held accountable if your commission is not
                    received due to these errors. Kindly double-check your
                    details before submission to avoid any issues
                  </FormLabel>{" "}
                  <FormLabel
                    component="legend"
                    style={{
                      fontSize: "0.85rem",
                      textOverflow: "ellipsis",
                      width: fullScreen ? "100%" : "65%",
                      paddingBottom: "10px",
                    }}
                  >
                    I confirm that I have trained the agent on the
                    responsibilities of being a RICA and POPIA agent and the
                    responsibilities as explained in the act.
                  </FormLabel>{" "}
                  <Grid container direction="row">
                    <a
                      href="https://zmdjhwyplkwfgwmmtwak.supabase.co/storage/v1/object/public/terms_and_conditions/RICA_Terms_and_Conditions.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      RICA
                    </a>
                    {" , "}
                    <a
                      href="https://zmdjhwyplkwfgwmmtwak.supabase.co/storage/v1/object/public/terms_and_conditions/POPIA_Zawadi_mrg.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      POPIA
                    </a>
                  </Grid>
                  <FormControlLabel
                    control={<Checkbox required />}
                    label="I Agree"
                    name="agreedToRicaTerms"
                    checked={dealerState.agreedToRicaTerms}
                    onChange={() => handleTrained()}
                  />
                </FormControl>
              </Grid>
            </form>
          </MuiPickersUtilsProvider>
        </DialogContent>

        {error && (
          <Alert
            style={{ width: "100%", marginBottom: "1rem" }}
            severity="error"
          >
            {error}
          </Alert>
        )}
        <DialogActions>
          <Button
            color="secondary"
            onClick={() => {
              setDealerState([]);
              closeDialog();
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            type="submit"
            variant="contained"
            color="primary"
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const styles = {
  inputContainer: {
    marginTop: 30,
  },
};
